export default __webpack_public_path__ + "static/media/provider_6.23355000.png";